import React from 'react';
import { IonContent, IonPage, useIonAlert, useIonRouter } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { Button, Alert } from 'react-bootstrap';
import { axius, func, types } from 'utils';
import { Header, IonLoading, TabsOffset } from 'components';
import { Form, Input, Rate } from 'antd';
import { _store } from '_Store';

interface Props extends RouteComponentProps, types.StateProps {}
const Review: React.FC<Props> = (props) => {
	const {
		__data: { order },
	} = _store.useState();

	const [form] = Form.useForm();
	const [presentAlert] = useIonAlert();
	const router = useIonRouter();

	const [step, setStep] = React.useState(1);
	const [rate, setRate] = React.useState({ mealRate: 0, deliveryRate: 0 });
	const [errMsg, setErrMsg] = React.useState('');
	const [loading, setLoading] = React.useState('');

	const ord = order;

	const submit = (v: any) => {
		if (
			rate.mealRate > 0 &&
			((ord.type === types.OrderTypes.DELIVERY && rate.deliveryRate > 0) ||
				ord.type === types.OrderTypes.PICKUP)
		) {
			setErrMsg('');
			setLoading('submitting review...');
			axius
				.post(`orders/${ord.uuid}/reviews`, {
					...rate,
					...v,
					orderId: ord.uuid,
				})
				.then((res) => {
					if (res.status === 201) {
						if (
							rate.mealRate <= 3 ||
							(ord.type === types.OrderTypes.DELIVERY && rate.deliveryRate <= 3)
						) {
							router.push(`/help/${ord.uuid}/low`);
						} else {
							setStep(2);
						}
					} else {
						presentAlert(res.message);
					}
					setLoading('');
				});
		} else {
			presentAlert(`You must at least choose a rating`);
		}
	};

	return (
		<IonPage id="Review">
			<Header {...props} showSearch={false} />

			<IonContent fullscreen={false}>
				<IonLoading
					open={loading ? true : false}
					message={loading}
					onCancel={() => setLoading('')}
				/>

				{step === 1 && (
					<div className="p-3">
						<Form
							form={form}
							layout="vertical"
							onFinish={submit}
							className="mt-4"
						>
							<h4 className="fw-600 mb-0s">Meal Review</h4>
							<Rate
								allowHalf={false}
								className="box"
								defaultValue={ord.reviews[0]?.mealRate}
								disabled={ord.reviews[0]?.id ? true : false}
								onChange={(mealRate) => setRate((sr) => ({ ...sr, mealRate }))}
							/>
							<div className="small mt-1 text-muted">Click to rate</div>

							<p>&nbsp;</p>

							{ord.type === types.OrderTypes.DELIVERY && (
								<>
									<h4 className="fw-600 mb-0s">Delivery Service Review</h4>
									<Rate
										allowHalf={false}
										className="box"
										defaultValue={ord.reviews[0]?.deliveryRate}
										disabled={ord.reviews[0]?.id ? true : false}
										onChange={(deliveryRate) =>
											setRate((sr) => ({ ...sr, deliveryRate }))
										}
									/>
									<div className="small mt-1 text-muted">Click to rate</div>
								</>
							)}

							<p>&nbsp;</p>

							{errMsg && (
								<Alert variant="danger" className="text-center">
									{errMsg}
								</Alert>
							)}

							<Form.Item
								label="Comment"
								name="comment"
								initialValue={ord.reviews[0]?.comment}
							>
								<Input.TextArea
									size="large"
									rows={4}
									disabled={ord.reviews[0]?.id ? true : false}
								/>
							</Form.Item>
							<div>&nbsp;</div>

							{!ord.reviews[0]?.id && (
								<Button
									type="submit"
									variant="secondary btn-block btn-md text-uppercases"
								>
									Submit Review
								</Button>
							)}
						</Form>
					</div>
				)}

				{step === 2 && (
					<div
						className="p-3 text-center d-flex justify-content-center align-items-center"
						style={{ height: '70vh' }}
					>
						<div style={{ width: '90vw' }}>
							<Rate defaultValue={3} disabled />
							<div>&nbsp;</div>
							<h4 className="fw-600 mb-0">
								Thank You <br /> For Your Feedback
							</h4>
							<div>&nbsp;</div>
							<div className="text-muted">Your feedback has been logged.</div>
							<p>&nbsp;</p>
							<p>&nbsp;</p>
							<Button
								type="submit"
								variant="secondary btn-block btn-md text-uppercases"
								onClick={() => func.redirect('/user/orders')}
							>
								Back to Home
							</Button>
						</div>
					</div>
				)}
				<TabsOffset />
			</IonContent>
		</IonPage>
	);
};

export default Review;
